import type { PlcManufacturerCodeLibrary } from "./types";

export const emersonCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "emerson",
  manufacturer_name: "Emerson",
  codes: [
    {
      id: "emerson-rx3i-g137-e4",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: null,
      code: "Group 137 / Error 4",
      code_type: "PLC Fault Table",
      title_ar: "Sequence Store Failure",
      description_ar: "PACSystems RX3i يوثق Sequence Store Failure كـGroup 137 Error Code 4 ضمن حالة Store محددة.",
      symptoms: ["Store للمشروع يفشل", "Fault Table يسجل Group 137 Error 4"],
      causes: ["حالة Store/Project تتجاوز أو تقترب من حدود موثقة حسب firmware/المشروع"],
      checks: [
        {
          step: 1,
          action: "سجل Group/Code والـfirmware وحالة الـStore.",
          expected: "Store يكتمل بدون fault.",
          faulty: "يتكرر Group 137 Error 4.",
        }
      ],
      solutions: ["جرّب Store بوضع STOP إذا الحالة تطابق ملاحظة المصنع.", "راجع firmware release notes وحدود المشروع."],
      severity: "عالية",
      source_title: "Emerson PACSystems RX3i CPU Important Product Information",
      source_section: "Sequence Store Failure (Group 137; Error Code 4)",
      keywords: ["Emerson", "PACSystems", "RX3i", "137", "4", "Sequence Store Failure"],
    },
    {
      id: "emerson-rx3i-g140-e145",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: null,
      code: "Group 140 / Error 145",
      code_type: "CPU Software Event",
      title_ar: "CPU Software Event",
      description_ar: "PACSystems RX3i يوثق CPU Software Event كـGroup 140 Error Code 145 ضمن نفس حالة Store الموثقة.",
      symptoms: ["Fault Table يسجل Group 140 Error 145", "ممكن يظهر ويا Sequence Store Failure"],
      causes: ["CPU software event مرتبط بحالة Store الموثقة"],
      checks: [
        {
          step: 1,
          action: "راجع Fault Table وسجل ترتيب الأحداث.",
          expected: "تحدد أول fault قبل الأحداث التابعة.",
          faulty: "Error 145 يظهر بعد/ويا fault آخر.",
        }
      ],
      solutions: ["عالج الحدث الأصلي قبل Error 145.", "راجع IPI/firmware إذا الحالة مرتبطة بـRUN Mode Store."],
      severity: "عالية",
      source_title: "Emerson PACSystems RX3i CPU Important Product Information",
      source_section: "CPU Software Event fault (Group 140; Error Code 145)",
      keywords: ["Emerson", "PACSystems", "RX3i", "140", "145", "CPU Software Event"],
    },  ],
};
